<template>
  <div id="app">
    <div class="promote-app">
      <div class="gr-promote-app" v-show="isShowPromoteApp && isMobileApp() && ($route.path === '/home' || $route.path === '/')">
        <a href="javascript: void(0)" class="gr-btn text-center p-5 cursor-pointer" v-on:click="hidePromote()">
          <img src="https://static.pizzahut.jp/jp/icons/close%402x.png" width="12" alt="" />
        </a>
        <div class="gr-btn">
          <div class="gr-icon-logo">
            <img src="https://static.pizzahut.jp/jp/logos/ph-logo-horizontal%402x.png" width="28" class="m-auto" alt="" />
          </div>

        </div>
        <div class="gr-content">
          <div class="gr-title">{{$t('promote_app_title')}}</div>
          <div class="gr-body">{{getTextInErrorMessage('PROMO-APP')}}</div>  
        </div>
        <div class="gr-action p-5 t10">
          <span class="" v-on:click="onlinkRedirect">
              {{$t('promote_app_btn')}}
          </span>
        </div>
      </div>
    </div>
    <component :is="layout" id="main-layout">
      <router-view></router-view>
    </component>
    <notifications/>
    <notifications id="notifications" group="notifications"/>
    <div class="override-loading popup-loading" v-bind:style="{display: loading}"></div>
    <v-dialog class="disposition-modal-confirm"/>
    <!-- <div class="override-loading popup-loading" style="display:block"></div> -->
  </div>
</template>

<style lang="scss">
  @import './assets/css/plugin/font-awesome.min.css';
  @import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
  @import './assets/css/main.css';
  @import './assets/css/home.css';
  @import './assets/css/fix.css';
  @import './assets/css/login.css';
  @import './assets/css/fix-all.css';
  @import 'assets/scss/main.scss';
  @import '@pizza-hut/fcds-ui/dist/fcds-ui.css';
  @import './assets/css/new_style.css';

  .alert {
    z-index: 999;
  }

  @media screen and (max-width: 800px) {
    #main-layout {
      display: flex;
      flex-direction: column;
    }
  }

  @media screen and (max-width: 48em) {
    #app {
      overflow: hidden;
    }
  }
</style>

<script>
  import moment from 'moment'
  import * as types from '@/store/types'
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import constants from "./constants";
  const main = () => import('./main.js')
  const ModalNotify = () => import('./components/popup/ModalNotify')
  const OrderASAP = () => import('./components/popup/OrderASAP')
  const ModalMaintain = () => import('./components/popup/ModalMaintain')
  

  const defaultLayout = 'main'
  let isManipulate = false

  export default {
    name: 'App',
    data() {
      return {
        loading: 'none',
        loadingCount: 0,
        isManipulate: false,
        isManipulateInternal: false,
        intervalObj: null,
        isShowPromoteApp: true
      }
    },
    watch: {
      '$route': {
        handler: 'routeChanged',
        //immediate: true,
      },
      loadingCount: function (newValue, oldValue) {
        if (this.loadingCount <= 0 && this.loading == 'none') {

        } else {
          if (this.loadingCount <= 0) {
            this.loading = 'none'
          } else {
            this.loading = 'block'
          }
        }
      },
      isManipulate: function (newValue, oldValue) {
        if (!newValue) {

        }
      }
    },
    computed: {
      ...mapGetters({
        selectedOrderTime: 'selectedOrderTime',
        categoryList: 'categoryList',
        selectedCategory: 'selectedCategory',
        selectedSubCategory: 'selectedSubCategory',
        paymentStatus: 'paymentStatus'
      }),
      layout() {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    },
    created: function () {
      var vm = this
      this.initABTesting(this, this.$const.AB_TESTING_FUNCTIONAL)
      this.intervalObj = setInterval(function () {
        vm.executeInternalTimeOut()
      }, 5000)
      this.$cart.init(this)

      registerEvents(this)
      loadCSS(this)
      this.registerEventIdleTime()

      if (this.isMobileApp() && (vm.$route.path === '/' || vm.$route.path === '/home')) {
        document.body.classList.add('promo-app-visible')
      }
      this.getDataErrorMessage()
      this.initMaintainModeEvent()
    },
    mounted() {
      let vm = this
      this.$root.$on('logout', () => {
        vm.logout()
      })
      this.$root.$on('onShowNotification', (title, message) => {
        title = title || vm.$t('message')
        message = message || vm.$t('message')
        vm.$modal.show(ModalNotify, {
          name: 'modal-notify',
          title: title,
          message: message
        }, {
          class: 'modal-menu',
          transition: 'nice-modal-fade',
          overlayTransition: 'overlay-fade',
          clickToClose: false,
          name: 'modal-notify'
        })
      })
      this.$root.$on('onProcessChangeCategory', () => {
        let menudeal = vm.$store.getters.menuDeal
        if (vm.empty(menudeal)) {
          let orderTime = vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''),
            vm.$disposition.getByKey(vm, 'collectionTimeValue', ''))
          if (!orderTime) {
            orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          }
          orderTime = this.convertSecond(orderTime)
          let data = {
            order_time: orderTime,
          order_type: vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0)
          }

          if (vm.$disposition.getByKey(vm, 'outletCode', '')) {
            data.outlet_code = vm.$disposition.getByKey(vm, 'outletCode', '')
          }

          vm.axios.getListCategory(data, function (response) {
            vm.data = response.data.data.items
            vm.$session.set('listCategory', response.data.data.items)
            let _menuDeal = {}
            for (let r in response.data.data.items) {
              _menuDeal = {
                slug: response.data.data.items[r].slug,
                uuid: response.data.data.items[r].uuid,
                lower_categories: response.data.data.items[r].lower_categories
              }
              break
            }
            if (vm.empty(_menuDeal) && response.data.data.items.length > 0) {
              _menuDeal = {
                slug: response.data.data.items[0].slug,
                uuid: response.data.data.items[0].uuid,
                lower_categories: response.data.data.items[0].lower_categories
              }
            }

            vm.$store.commit('setMenuDeal', _menuDeal)
            let slug = _menuDeal.slug
            // if (_menuDeal.lower_categories && _menuDeal.lower_categories.length > 0) {
            //   slug = _menuDeal.lower_categories[0].slug
            // }
          if (!this.$route.query.hasOwnProperty('isShowWarning')) {
            vm.$router.push({'name': 'category', 'params': {'slug': slug}})
          }
          })
        } else {
        if (!this.$route.query.hasOwnProperty('isShowWarning')) {
          vm.$router.push({'name': 'category', 'params': {'slug': menudeal.slug}})
        }
      }
      })
    },
    destroyed () {
      clearInterval(this.intervalObj)
      document.body.classList.remove('promo-app-visible')
      this.$root.$off('onMaintainMode')
    },
    beforeDestroy: function () {
      this.$bus.$off('loading');
    },
    methods: {
      ...mapActions({
        setOrderTime: 'setOrderTime',
        setCategoryList: types.SET_CATEGORY_LIST,
        setSelectedCategory: types.SET_SELECTED_CATEGORY,
        setSelectedSubCategory: types.SET_SELECTED_SUB_CATEGORY,
				setSidebarOpen: types.SET_SIDEBAR_OPEN,
				setHoSidebarOpen: types.SET_HOME_SIDEBAR_OPEN,
        setHutReward: types.SET_HUT_REWARD
      }),
      hidePromote () {
        this.isShowPromoteApp = false
        document.body.classList.remove('promo-app-visible')
      },

      onlinkRedirect () {
        window.open(this.$const.ONE_LINK, '_blank')
      },
      logout: function () {
        let vm = this
        this.$auth.logout({
          data: {
            token: this.$auth.user().token
          },
          success: function (response) {
            if (response.data.status) {
              this.$router.push('/')
              this.$cart.removeAll(this, (err, res) => {})
            } else {
              this.$notify({
                type: 'Error',
                title: response.data.error.msg
              })
            }
            vm.setHutReward({})
            vm.$session.remove('listCategoryMembership')
          },
          error: function (data) {
            this.$notify({
              type: 'Error',
              title: this.$t('message_logout_error')
            })
          }
        })
      },
      routeChanged() {
      	this.setHoSidebarOpen(false)
        this.getCategoryList(false)
      },
      showOrderASAP: function (message, hideSuggestionText) {
        let vm = this
        this.$modal.show(OrderASAP, {
            parentlink: vm.getCurrentPath(),
            message: message,
            hideSuggestionText: hideSuggestionText
          },
          {
            class: ''
          })
      },
      getCategoryList: function (loadAgain = false, orderType = '') {
        var vm = this

        if (!vm.categoryList || !vm.categoryList.length || loadAgain) {
          let orderTime = vm.convertDateTimeFromTimezoneToUTC(vm.$disposition.getByKey(vm, 'timezone', ''),
            vm.$disposition.getByKey(vm, 'collectionTimeValue', ''))
          if (!orderTime) {
            orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          }
          orderTime = this.convertSecond(orderTime)
          let request = {
            order_time: orderTime,
            lang: vm.$session.get('lang'),
            order_type: (orderType) ? orderType : vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0),
            outlet_code: vm.getOutletCode(this) || constants.DEFAULT_OUTLET
          }

          if (vm.$disposition.getByKey(vm, 'outletCode', '')
            || vm.$route.params.outlet
          ) {
            request.outlet_code = vm.$disposition.getByKey(vm, 'outletCode', '') || vm.$route.params.outlet
          }

          request = vm.parseQueryString(request)

          vm.axios.getListCategory(request, function (response) {
            vm.setCategoryList(response.data.data.items)
            vm.$session.set('listCategory', response.data.data.items)

            vm.bindNav();
          })
        } else {
          vm.bindNav();
        }

        /*if (vm.$route.name == vm.$const.HEADER_MENU.CATEGORY || vm.$route.name == vm.$const.HEADER_MENU.COMBO_DETAIL ||
          vm.$route.name == vm.$const.HEADER_MENU.TOPIC || vm.$route.name == vm.$const.HEADER_MENU.TOPIC_DETAIL) {

        }*/
      },
      bindNav: function () {
        let vm = this
        let selectedCategory = null;
        let selectedSubCategory = null;
        let slugParent = vm.$route.params.slug
        let slugSub = vm.$route.params.sub

        if (slugParent == vm.$const.MENU_COUPON) {
          let selectedCategory = {};
          selectedCategory.uuid = vm.$const.COUPON_UUID;

          vm.setSelectedCategory(selectedCategory)
          vm.$root.$emit('showHideCart', false)
          //vm.$router.push({'name': 'login'})
          return;
        } else if (vm.$route.name == vm.$const.HEADER_MENU.CATEGORY) {
          if (!slugParent && vm.categoryList && vm.categoryList.length) {
            if (vm.categoryList[0].lower_categories && vm.categoryList[0].lower_categories.length) {
              vm.setSelectedCategory(vm.categoryList[0])
              vm.setSelectedSubCategory(vm.categoryList[0].lower_categories[0])
              vm.redirectToMenuPage(vm.categoryList[0].slug, vm.categoryList[0].lower_categories[0].slug, null, true);
              return;
            } else {
              vm.setSelectedCategory(vm.categoryList[0])
              vm.setSelectedSubCategory(null)
              vm.redirectToMenuPage(vm.categoryList[0].slug, null, null, true);
              return;
            }
          }
        }

        if (slugParent == vm.$const.MENU_COUPON) {
          selectedCategory = {};
          selectedCategory.uuid = vm.$const.COUPON_UUID;
        } else if (vm.categoryList && vm.categoryList.length) {
          for (let r in vm.categoryList) {
            if (r == 0) {
              let _menuDeal = {
                slug: vm.categoryList[r].slug,
                uuid: vm.categoryList[r].uuid,
                lower_categories: vm.categoryList[r].lower_categories
              }
              vm.$store.commit('setMenuDeal', _menuDeal)
            }

            if (vm.categoryList[r].slug == slugParent) {
              selectedCategory = vm.categoryList[r];
              vm.sub = vm.categoryList[r].lower_categories

              let lowerCategories = vm.categoryList[r].lower_categories;

              if (lowerCategories && lowerCategories.length) {
                if (!slugSub) {
                  let subCategory = vm.categoryList[r].lower_categories[0];

                  vm.setSelectedCategory(selectedCategory)
                  vm.setSelectedSubCategory(subCategory)
                  vm.redirectToMenuPage(selectedCategory.slug, subCategory.slug, null, true);
                  return;
                } else {

                  for (let s in lowerCategories) {
                    if (lowerCategories[s].slug == slugSub) {
                      selectedSubCategory = lowerCategories[s]
                      break;
                    }
                  }
                }
              }

              break;
            }
          }
        }

        vm.$session.set('categoryUuid', selectedCategory ? selectedCategory.uuid : '')
        vm.setSelectedCategory(selectedCategory)
        vm.setSelectedSubCategory(selectedSubCategory)
      },
      registerEventIdleTime: function () {
        window.addEventListener("mousemove", this.executeIdleTimeOut);
        window.addEventListener("mousedown", this.executeIdleTimeOut);
        window.addEventListener("keypress", this.executeIdleTimeOut);
        window.addEventListener("DOMMouseScroll", this.executeIdleTimeOut);
        window.addEventListener("mousewheel", this.executeIdleTimeOut);
        window.addEventListener("touchmove", this.executeIdleTimeOut);
        window.addEventListener("MSPointerMove", this.executeIdleTimeOut);
        window.addEventListener("click", this.executeIdleTimeOut);
      },
      executeIdleTimeOut: function (e) {
        let vm = this
        if (!vm.isManipulate) {
          vm.isManipulate = true

          checkIdleTime(vm, function (res) {
            if (res) {
              vm.$router.go()
            }

            vm.isManipulate = false
          })
        }
      },
      executeInternalTimeOut: function (e) {
        let vm = this
        if (!vm.isManipulateInternal) {
          vm.isManipulateInternal = true

          vm._executeInternalTimeOut(vm, function (res) {
            vm.isManipulateInternal = false
          })
        }
      },
      _executeInternalTimeOut (vm, callback) {
        if (!vm.checkValidDateTimeOfCart(vm)) {
          vm.resetTimeToASAP(vm)
          vm.$cart.updateOrderTime(vm, {'order_time': vm.getTimePickerDate(vm)})
        }
        callback(true)
      },
      initMaintainModeEvent () {
        var vm = this
        this.$root.$on('onMaintainMode', () => {
          const params = { 'scope': 'web_maintenance' }
          // call api check maintain mode
          vm.axios.apiTenant.getConfigByClient(params, function (response) {
            if (response.data !== undefined && response.data === 1) {
              vm.$modal.show(ModalMaintain, {
                name: 'modal-notify',
                title: vm.getTextInErrorMessage(vm.$const.MAINTAIN_CODE_TITLE) || vm.$t('maintain_title'),
                message: vm.getTextInErrorMessage(vm.$const.MAINTAIN_CODE_MESSAGE) || vm.$t('maintain_message')
              }, {
                class: 'modal-maintain',
                height: 'auto',
                transition: 'nice-modal-fade',
                overlayTransition: 'overlay-fade',
                clickToClose: false,
                name: 'modal-notify'
              })
            }
          })
        })
      },
      getDataErrorMessage () {
        var vm = this
        let messages = this.$session.get('messages')
        const timestamp = this.$session.get('timestamp_message')
        const params = {
          'ignore_limit': 1,
          'timestamp': 0
        }
        if (timestamp) {
          params.timestamp = timestamp
        }
        if (!messages) {
          messages = []
        }
        this.axios.apiTenant.getErrorMessage(params, response => {
          // Create session message
          for (let i = 0; i < response.data.data.items.length; i++) {
            const element = response.data.data.items[i]
            let check = false
            for (let i = 0; i < messages.length; i++) {
              const item = messages[i]
              if (item.error_code === element.error_code) {
                if (element.active === 1) {
                  messages[i] = element
                } else {
                  messages.splice(i, 1)
                }
                check = true
                break
              }
            }
            if (!check && element.active === 1) {
              messages.push(element)
            }
          }
          vm.$session.set('messages', messages)
          vm.$session.set('timestamp_message', response.data.data.timestamp)
        }, error => {
          console.log('error', error)
        })
      }
    }
  }

  function registerEvents(vm) {
    vm.$bus.$on(vm.$const.EVENT_BUS.LOADING, ($status) => {
      if ($status) {
        vm.loadingCount++
      } else if (vm.loadingCount > 0) {
        vm.loadingCount--
      }
    })

    vm.$bus.$on(vm.$const.EVENT_BUS.RELOAD_PAGE, () => {
      window.location.reload(true)
    })
    vm.$bus.$on(vm.$const.EVENT_BUS.LOAD_CATEGORY, (loadAgain = false) => {
      vm.getCategoryList(loadAgain)
    })

    vm.$bus.$on(vm.$const.EVENT_BUS.SHOW_ASAP, (data) => {
      let message = vm.$t('hutfe.error_text_fe_order_time_in_past')
      let hideSuggestionText = false
      if (data && data !== true && data.hasOwnProperty('message')) {
        message = data.message
      }
      if (data && data.hideSuggestionText) hideSuggestionText = data.hideSuggestionText

      vm.showOrderASAP(message, hideSuggestionText)
    })

    vm.$bus.$on(vm.$const.EVENT_BUS.BACK_BUTTON_CLICK, () => {
      if (vm.$route.name == 'payment-status') {
        if (vm.paymentStatus) {
          vm.$router.replace({name: 'home'})
        } else {
          vm.$router.replace('/checkout')
        }
      } else if (vm.$route.name == 'checkout') {
        vm.redirectToPage(vm.$const.SLUG_LIST.PIZZA)
      } else if (vm.$route.name != 'tracker-order') {
        if (window.history.length > 2) {
          vm.$router.go(-1)
        } else {
          vm.redirectToPage(vm.$const.SLUG_LIST.DEAL)
        }
      } else {
        vm.$router.push({name: 'home'})
      }
    })

    vm.$root.$on(vm.$const.EVENT_BUS.REDIRECT_TO_MENU_PAGE, (slug = null, sub = null, uuid = null, isReplace = false) => {
      if (isReplace) {
        vm.$router.replace({
          'name': 'category',
          'params': {
            slug: slug,
            sub: sub ? sub : null,
            uuid: uuid ? uuid : null
          }
        })
      } else {
        vm.$router.push({
          'name': 'category',
          'params': {
            slug: slug,
            sub: sub ? sub : null,
            uuid: uuid ? uuid : null
          }
        })
      }
    })
  }

  function loadCSS(vm) {
    try {
      require('@/assets/css/lang-' + vm.$i18n.locale + '.css')
    } catch (ex) {

    }
  }

  function checkIdleTime(vm, callback) {
    let time = localStorage.time
    let now = moment()

    if (time) {
      time = moment(time)

      if (time.isValid && now.diff(time, 'hours', true) >= vm.$const.TIMEOUT_CART) {
        vm.$cart.removeAll(vm, function (err, res) {
          if (callback) {
            callback(res)
          }
        })
      } else {
        if (callback) {
          callback(null)
        }
      }
    } else {
      if (callback) {
        callback(null)
      }
    }

    localStorage.time = moment()
  }
</script>



// WEBPACK FOOTER //
// src/App.vue